export default __webpack_public_path__ + "static/media/pDawn-endonuclease-sequence.3069eac6.pdf";